import { appleEedClient } from '../api/clients';
import type { AppleEedComponents } from '../api/apple-eed';

export type AppleEedEmergencyContact = AppleEedComponents['schemas']['EmergencyContact'];
export type AppleEedCallInformation = AppleEedComponents['schemas']['CallInformation'];
export type AppleEedCallerInformation = AppleEedComponents['schemas']['CallerInformation'];
export type AppleEedAdditionalDataResponse =
  AppleEedComponents['schemas']['GetCallAdditionalDataResponse'];

export async function fetchAppleEedAdditionalData(
  phoneNumber: string,
): Promise<AppleEedAdditionalDataResponse | null> {
  const { data } = await appleEedClient().GET('/v1/get-additional-data/{callId}', {
    params: { path: { callId: phoneNumber } },
  });

  return data ?? null;
}

export async function requestAppleEedMedia(incidentId: string, phoneNumber: string): Promise<void> {
  const { response } = await appleEedClient().POST('/v1/send-agency-request/media', {
    body: { incidentId, callId: phoneNumber },
  });

  if (!response.ok) {
    throw new Error(`Failed to request Apple EED media (HTTP ${response.status})`);
  }
}

export async function requestAppleEedVideo(callId: string, videoId: string): Promise<void> {
  const { response } = await appleEedClient().POST('/v1/send-agency-request/video', {
    body: { callId, videoId },
  });

  if (!response.ok) {
    throw new Error(`Failed to resend Apple EED video request (HTTP ${response.status})`);
  }
}
